module.exports = __webpack_public_path__ + "static/media/ph-bottom.6c35d17b.png";